var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_14402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "currentColor",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14H7.5C7.22386 14 7 14.2239 7 14.5V17C7 17.2761 7.22386 17.5 7.5 17.5H9C9.27614 17.5 9.5 17.2761 9.5 17V14.5C9.5 14.2239 9.27614 14 9 14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7002 11.5H11.2002C10.9241 11.5 10.7002 11.7239 10.7002 12V17C10.7002 17.2761 10.9241 17.5 11.2002 17.5H12.7002C12.9763 17.5 13.2002 17.2761 13.2002 17V12C13.2002 11.7239 12.9763 11.5 12.7002 11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.5H15C14.7239 8.5 14.5 8.72386 14.5 9V17C14.5 17.2761 14.7239 17.5 15 17.5H16.5C16.7761 17.5 17 17.2761 17 17V9C17 8.72386 16.7761 8.5 16.5 8.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_14402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquity);
export default __webpack_public_path__ + "static/media/equity.7ce58241fa2bb6f04da962c851708f43.svg";
export { ForwardRef as ReactComponent };